/** A compact price-history mark shared by Flights and the home fare strip. */
export function FareSparkline({ values, atLow }: { values: number[]; atLow: boolean }) {
  if (values.length < 2) return null;
  const [width, height] = [96, 28];
  const low = Math.min(...values);
  const high = Math.max(...values);
  const points = values.map((value, index) => [
    1 + (index * (width - 6)) / (values.length - 1),
    high === low ? height / 2 : 3 + (height - 6) * (1 - (value - low) / (high - low)),
  ]);
  const path = points.map(([x, y]) => `${x},${y}`).join(" ");
  const [endX, endY] = points[points.length - 1];
  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      className="h-7 w-24 shrink-0"
      role="img"
      aria-label={`Price history, ${values.length} moves`}
    >
      <polyline points={path} fill="none" stroke="currentColor" strokeWidth="2" className="text-accent" />
      <circle cx={endX} cy={endY} r="3" className={atLow ? "fill-green-400" : "fill-accent"} />
    </svg>
  );
}
